<template>
  <section>
    <article v-if="total > 0">
      <infinite-scroll :callback="getConnections" distance="5">
        <ul>
          <li  class="bottom-space" v-for="(connectedUser, index) in connections" :key="index" @click="goToConnectedUser(connectedUser.userName)">
            <img :src="thumbnail(connectedUser.avatar)" :alt="connectedUser.userName" />
            <span>{{connectedUser.userName}}<span v-if="connectedUser.isEngStaff" class="staff-shield"><i class="fal fa-shield-check"></i></span></span>
          </li>
        </ul>
        <span class="loader" v-if="loading"></span>
      </infinite-scroll>
    </article>
    <article v-if="!loading && total <= 0">
      <p>{{placeholder}}</p>
    </article>
  </section>
</template>

<script>
import InfiniteScroll from '@/components/Controls/InfiniteScroll'
import imageProxy from '@/libs/image-proxy'
import componentState from '@/mixins/component-state'

import state from '../state'
import i18n from '@/i18n'

export default {
  mixins: [componentState],
  components: {
    InfiniteScroll
  },
  props: ['user', 'profile'],
  data: function () {
    return {
      limit: 16,
      offset: 0,
      total: 0,
      hasMore: true,
      loading: false,
      connections: []
    }
  },
  computed: {
    placeholder: function () {
      return this._get(state.editable.profile, false) ? i18n.t('sectionProfile.followingMessage') : this.user.userName + i18n.t('sectionProfile.notFollowingMessage')
    }
  },
  mounted: function () {
    this.getConnections()
  },
  methods: {
    getConnections: function () {
      if (this.loading || !this.hasMore || !this.user.userName) {
        return
      }

      this.loading = true
      const connectionConfig = { username: this.user.userName, limit: this.limit, offset: this.offset }
      this.$store.dispatch('getFollowing', connectionConfig).then((response) => {
        this.connections.push.apply(this.connections, response.users)
        this.total = response.total
        this.hasMore = response.hasMore
        this.loading = false
        this.offset += this.limit
      }, (messages) => {
        this.connections.loading = false
        this.handleError(messages)
      })
    },
    goToConnectedUser: function (username) {
      this.$router.push({ name: 'profile', params: { username } })
    },
    thumbnail: function (avatar) {
      return imageProxy.proxy(avatar, { width: 100, height: 100 })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/utils.scss';

ul {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: start;
      -ms-flex-pack: start;
          justify-content: flex-start;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
  @media screen and (max-width: 425px) {
    justify-content: space-around;
  }

 li {
    width: 125px;
    text-align: center;
    margin: 1em;
    @media screen and (max-width: 425px) {
      margin: 1em 0;
    }

    img {
      border: solid 3px #ffffff;
      height: 100px;
      width: 100px;
      max-width: 100%;
      transition: all 0.5s;
      -o-object-fit: cover;
      object-fit: cover;
      &:hover {
        border: solid 3px $primary;
        cursor: pointer;
      }
      @include hover-cards-effect
    }

    span {
      font-size: 0.9rem;
      color: #727272;
      line-height: 1.3rem;
      display: inline;
    }
  }
}
.loader {
  display: block;
  font-size: 2rem;
  margin: 1rem auto;
}
.bottom-space {
  padding-bottom: 15px;
}
</style>
